<template>
  <div class="container">
    <div class="row clear-bottom title-row">
      <div class="col s12">
        <h5>Phrases
          <button class="btn right waves-effect cyan" v-on:click="newEmptyPhrase()" v-if="$store.claims.phrases & 2">New</button>
        </h5>
        <label>
          <input type="checkbox" class="filled-in" v-model="showOnlyTranslated"/>
          <span>Only show phrases that lacks translation in the preferred language</span>
        </label>
      </div>
    </div>
    <div class="progress" id="loader">
        <div class="indeterminate"></div>
    </div>
    <SearchBox v-model="searchTerm" placeholder="Search for a phrase"/>
    <ul class="collapsible popout" v-if="phrases && !loading">
      <div id="wrong_keyword">
        <p>No phrases found with keyword</p>
      </div>
      <li v-for="(phrase, phraseIndex) in slicedPhrases" :key='phraseIndex + phraseRenderCount' v-if="!showOnlyTranslated || phrase.noTranslation">
        <div v-if="!phrase.edit && phrase.translations && phrase.translations.length > 0" class="collapsible-header" dir="auto">
          {{ trunc(phrase.title, 80) }}
          <span class="badge animate" v-bind:style="{'opacity': phrase.noTranslation ? '1' : '0'}"><i class="material-icons left orange-text">warning</i>No translation for preferred language</span>
        </div>
        <div v-if="!phrase.edit && !phrase.translations" class="collapsible-header"><i class="material-icons left orange-text">warning</i>Phrase has no translations</div>
        <div v-if="phrase.edit" class="collapsible-header">Editing phrase</div>
        <div class="collapsible-body white">
          <div class="space">
            <div class="row">
              <div class="col s12">
                <div v-for="(translation, translationIndex) in phrase.translations" :key='translationIndex' class="translation-edit-row">
                  <form :id="phraseIndex+'.'+translationIndex+'u'">
                    <input type="file" name="file" class="hide" :id="phraseIndex+'.'+translationIndex+'f'" v-on:change="addAttachment(phrase, phraseIndex+'.'+translationIndex+'u', 'audio', translation.language)">
                  </form>
                  <div v-if="phrase.edit" class="translation-edit-row-input">
                    <div class="input-field">
                      <input :id="phraseIndex+'.'+translationIndex" type="text" v-model="translation.text" dir="auto">
                      <label :for="phraseIndex+'.'+translationIndex">{{languages[translation.language]}}</label>
                    </div>
                    <a v-if="phrase.attachments.filter(x => x.type == 'audio' && x.language == translation.language).length == 0" href="#" class="btn-flat btn-small blue-text text-darken-2" v-on:click="trigger(phraseIndex+'.'+translationIndex+'f')">
                      Upload audio
                      <i class="material-icons right">cloud_upload</i>
                    </a>
                    <span v-if="phrase.attachments.filter(x => x.type == 'audio' && x.language == translation.language).length > 0">
                      <a href="#" v-if="player == null" class="btn-flat btn-small blue-text text-darken-2" v-on:click="playAudio(phrase, translation.language)">
                        Play audio
                        <i class="material-icons right">play_circle_filled</i>
                      </a>
                      <a href="#" v-if="player != null && player.id == translation.language" class="btn-flat btn-small blue-text text-darken-2" v-on:click="stopAudio()">
                        Stop audio
                        <i class="material-icons right">stop</i>
                      </a>
                      <a href="#" class="btn-flat btn-small blue-text text-darken-2" v-on:click="removeAttachment(phrase, phrase.attachments.filter(x => x.type == 'audio' && x.language == translation.language)[0], phraseIndex+'.'+translationIndex+'f')">
                        Remove audio
                        <i class="material-icons right">delete</i>
                      </a>
                    </span>
                    <a href="#" class="btn-flat btn-small blue-text text-darken-2 right" v-on:click="removeTranslation(phrase, translation.language)">
                      Remove translation
                      <i class="material-icons right">remove_circle</i>
                    </a> 
                  </div>
                  <div v-if="!phrase.edit && translation.text.length > 0">
                  <h6>{{languages[translation.language]}}</h6>
                    <pre style="display: inline">{{translation.text }}</pre>
                    <span v-if="phrase.attachments.filter(x => x.type == 'audio' && x.language == translation.language).length > 0">
                      <a href="#" v-if="player == null" class=" right" v-on:click="playAudio(phrase, translation.language)">
                        <i class="material-icons right">play_circle_filled</i>
                      </a>
                      <a href="#" v-if="player != null && player.id == translation.language" class=" right" v-on:click="stopAudio()">
                        <i class="material-icons right">stop</i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row btn-bottom-row">
            <div class=" col s12 m6">
              <button v-if="phrase.edit" class="btn-flat grey-text text-darken-2" v-on:click="deletePhrase(phrase)">Delete</button>
            </div>
            <div class=" col s12 m6 right-align">
              <button v-if="!phrase.edit && $store.claims.phrases & 2" class="btn-flat grey-text text-darken-2" v-on:click="enterEditMode(phrase)">Edit</button>
              <button v-if="phrase.edit && !phrase.new" class="btn-flat grey-text text-darken-2" v-on:click="exitEditMode(phrase)">Cancel</button>
              <button v-if="phrase.edit" class="btn-flat grey-text text-darken-2" v-on:click="savePhrase(phrase)">Save</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<style scoped>
.translation-edit-row {
  margin-top: 30px;
}
.translation-edit-row-input {
  margin-top: 30px;
  margin-bottom: 50px;
}
.btn-small {
  transform: scale(0.7);
  margin: 0;
  padding: 0;
}
.animate {
  transition: 0.5s ease;
}
.scale {
  opacity: 1;
}
.hide {
  opacity: 0;
}
.input-field.suffix a {
  position: absolute;
  width: 3rem;
  font-size: 2rem;
  transition: color 0.2s;
  top: 0px;
  right: 0px;
}
.infobadge {
  font-weight: 300;
  font-size: 0.8rem;
  color: #fff;
  background-color: #26a69a;
  border-radius: 2px;
}
.title-row {
  padding: 10px;
}
.col-btn {
  margin-top: 20px;
}
.btn-bottom-row {
  border-top: #efefef solid 1px;
  padding-top: 5px;
  height: 50px;
  margin: 0px;
}
.collapsible-body {
  margin: 0;
  padding: 0;
  border-bottom: none;
}
.space {
  padding: 20px;
}
.input-field.suffix input,
.input-field.suffix textarea {
  margin-right: 3rem;
  width: 92%;
  width: calc(100% - 3rem);
}

.input-field.suffix textarea {
  padding-top: 0.8rem;
}

.input-field.suffix label {
  margin-right: 3rem;
}

@media only screen and (max-width: 992px) {
  .input-field.suffix input {
    width: 86%;
    width: calc(100% - 3rem);
  }
}

@media only screen and (max-width: 600px) {
  .input-field.suffix input {
    width: 80%;
    width: calc(100% - 3rem);
  }
}

.no-padding {
  padding: 0;
}
.clear-bottom {
  margin-bottom: 0;
}
.show {
  display: block;
}
</style>

<script>
import SearchBox from "../components/SearchBox";
import axios from 'axios';
export default {
  name: "phrases",
  data() {
    return {
      searchTerm: "",
      phrases: [],
      modal: {},
      languages: {},
      selectors: [],
      player: null,
      showOnlyTranslated: false,
      enities: 30,
      phrasesLoaded:false,
      limit:500,
      phraseRenderCount:0,
      loading:false,
      cancelSource:null,
    };
  },
  components:{
    SearchBox
  },
  async created() {
    await this.fetchLanguages();

    document.getElementById("loader").style.display = "none";
    document.getElementById("wrong_keyword").style.display = "none";
    
    this.$watch('$store.preferredLanguage', function () {
      this.phrases.forEach(p => this.setTitle(p));
      this.phraseRenderCount = Math.random()
        .toString(36);
    })
  },
  mounted() {
    // collapsible is declared in the app.vue 
    // M.updateTextFields();
    // M.Collapsible.init(this.$el.querySelector(".collapsible"), {
    //   accordion: true
    // });
    window.onscroll = this.scrolling;
  },
  methods: {
    enterEditMode(p){
      this.loading = true;
      p.edit = true;
      this.loading = false;
    },
    exitEditMode(p){
      this.loading = true;
      p.edit = false;
      this.loading = false;
    },
    scrolling(){
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        if(this.enities < this.filteredPhrases.length)
          this.enities += 10;
      }

    },
    trunc(t, n) {
      if(t !== undefined)
        return t.length > n ? t.substr(0, n - 1) + "..." : t;
      else
        return ''
    },
    upload(phrase, formId) {
      this.$http
        .post("/phrases/" + phrase.id + "/attachments", formData)
        .then(r => {
          console.log("Success");
        })
        .catch(r => {
          console.log(r);
        });
    },
    trigger(id) {
      document.getElementById(id).click();
    },
    addAttachment(phrase, formId, type = "", language = "") {
      let formData = null;
      if (formId !== "") {
        formData = new FormData(document.getElementById(formId));
        formData.append("type", type);
        formData.append("language", language);
      }
      phrase.attachments.push({
        id: null,
        type: type,
        language: language,
        pendingUpload: formData
      });
    },
    removeAttachment(phrase, attachment, inputId = "") {
      document.getElementById(inputId).value = "";
      phrase.attachments.splice(phrase.attachments.indexOf(attachment), 1);
      if (phrase.pendingDelete === undefined) {
        phrase.pendingDelete = [];
      }
      phrase.pendingDelete.push(attachment.id);
    },
    playAudio(phrase, languageId) {
      let attachment = phrase.attachments.filter(
        x => x.type == "audio" && x.language == languageId
      )[0].id;
      if (attachment == null) {
        M.toast({
          html: "You need to save your changes before you can playback"
        });
        return;
      }
      this.player = new Audio(
        window.baseURL +
          "/phrases/" +
          phrase.id +
          "/attachments/" +
          attachment +
          "/?token=" +
          this.$store.token
      );
      this.player.id = languageId;
      this.player.addEventListener("ended", () => {
        this.player = null;
      });
      this.player.play();
    },
    stopAudio() {
      this.player.pause();
      this.player = null;
    },
    getAttachments(phrase, type = "", language = "") {
      let attachments = phrase.attachments;
      if (type !== "") attachments = attachments.filter(x => x.type === type);
      if (language !== "")
        attachments = attachments.filter(x => x.language === language);
      return attachments;
    },
    getAudio(phrase, language) {
      let audio = this.getAttachments(phrase, "audio", language);
      return audio.length == 0 ? null : audio[0];
    },
    setTitle(p) {
      if (p.translations && p.translations.length > 0) {
        let preferred = p.translations.find(
          t => t.language == this.$store.preferredLanguage
        );
        if (preferred !== undefined && preferred.text != "") {
          p.title = preferred.text;
          p.noTranslation = false;
        } else {
          p.title = p.translations[0].text;
          p.noTranslation = true;
        }
      } else {
        p.title = "No translations found";
      }
    },
    newEmptyPhrase() {
      this.selectors = [];
      let newTranslations = [];
      Object.keys(this.languages).forEach(l => {
        newTranslations.unshift({
          text: "",
          language: l
        });
      });
      this.phrases.unshift({
        translations: newTranslations,
        attachments: [],
        edit: true,
        new: true
      });
      M.Collapsible.getInstance(this.$el.querySelector(".collapsible")).open(0);
    },
    addTranslation(phrase, language) {
      if (this.languages[language] == null) return;
      if (phrase.translations == null) phrase.translations = [];
      phrase.translations.push({
        text: "",
        language: language
      });
    },
    removeTranslation(phrase, language) {
      phrase.translations = phrase.translations.filter(t => {
        return t.language !== language;
      });
      if (phrase.pendingDelete == undefined || phrase.pendingDelete == null)
        phrase.pendingDelete = [];
      phrase.attachments = phrase.attachments.filter(
        x => x.language !== language
      );
      phrase.attachments
        .filter(x => x.language == language)
        .forEach(x => phrase.pendingDelete.push(x.id));
    },
    async fetchPhrases() {
      var cursorID = "";
      // api call to get all phrases at once
      // await this.$store.getPhrasesLimited(cursorID);
      var phrases = this.$store.phrases;
      phrases.forEach(p => {
            if(p.attachments == null){
              p.attachments = []
            }
            p.edit = false;
            this.setTitle(p);
            Object.keys(this.freeLanguages(p)).forEach(l => {
              if(p.translations)
              p.translations.unshift({
                text: "",
                language: l
              });
            });
          });
          document.getElementById("loader").style.display = "none";
          this.phrases = phrases;
    },
    async phraseSearch(){
      var searchQuery =  this.searchTerm;
      document.getElementById("loader").style.display = "";
      if(searchQuery == ""){
        document.getElementById("loader").style.display = "none";
      }
      this.phrases = [];
      if (this.cancelSource) {
        this.cancelSource.cancel('previous search request cancelled');
      }
      this.cancelSource = axios.CancelToken.source();
      if(searchQuery.length==0){
        this.searchSuggestion=[];
        return;
      }
     this.$http.get('search/phraseSearch?text=' + searchQuery +'&lang_id='+this.$store.preferredLanguage, {
        cancelToken: this.cancelSource.token,
        headers: {
          type:'phrase'
        }
      }).then((r) => {
          if (r) {
            this.cancelSource = null;
            var vm = this;
            var phrases = [];

            // print message if search dont match any phrases
            if(r.data.length != 0){
              document.getElementById("wrong_keyword").style.display = "none";
            }
            if(r.data.length == 0){
              document.getElementById("wrong_keyword").style.display = "";
            }


            r.data.forEach(function(p){
              if(p.attachments == null){
              p.attachments = []
              }
              p.edit = false;
              vm.setTitle(p)
              Object.keys(vm.freeLanguages(p)).forEach(l => {  
                if(p.translations)
                p.translations.unshift({
                  text: "",
                  language: l
                });
              });

              document.getElementById("loader").style.display = "none";
              
              vm.phrases.push(p)
            })
          }
        }, err => {});
    },

    fetchPhrasesByLimit(){
       this.$http.get('/phrases?limit='+this.limit).then(response => {
          response.data.forEach(p => {
            if(p.attachments == null){
              p.attachments = []
            }
            p.edit = false;
            this.setTitle(p);
            Object.keys(this.freeLanguages(p)).forEach(l => {
            if(p.translations)
              p.translations.unshift({
                text: "",
                language: l
              });
            });
          });
          this.phrases = this.phrases.concat(response.data);
          if (response.data && response.data.length == 0)
            this.phrasesLoaded = true
          if (!this.phrasesLoaded)
            this.fetchPhrasesByLimit()
          else
            document.getElementById("loader").style.display = "none";
        },
        response => {}
        );
    },
    async fetchLanguages() {
      let map = {};
      if(this.$store.languages.length)
      this.$store.languages.forEach(l => {
        map[l.id] = l.name;
      });
      else  
      await this.$http.get("/languages").then(r => {
        r.data.forEach(l => {
          map[l.id] = l.name;
        })
      })
      this.languages = map;
    },
    addNewPhrase(phrase) {
      this.$http.post("/phrases", phrase).then(
        response => {
          let id = response.data.id;
          phrase.attachments.filter(x => x.pendingUpload != null).forEach(x => {
            this.$http
              .post("/phrases/" + id + "/attachments", x.pendingUpload)
              .then(response => {
                x.id = response.data.id;
                x.pendingUpload = null;
                M.toast({ html: "Attachment uploaded" });
              })
              .catch(x => {
                M.toast({ html: "Failed to upload attachment" });
              });
          });
          M.toast({ html: "Phrase saved" })          
          this.fetchPhrases();
        },
        response => {}
      );
    },
    updatePhrase(phrase) {
      this.$http.put("/phrases/" + phrase.id, phrase).then(
        response => {
          phrase.attachments.filter(x => x.pendingUpload != null).forEach(x => {
            this.$http
              .post("/phrases/" + phrase.id + "/attachments", x.pendingUpload)
              .then(response => {
                x.id = response.data.id;
                x.pendingUpload = null;
                M.toast({ html: "Attachment uploaded" });
              })
              .catch(x => {
                M.toast({ html: "Failed to upload attachment" });
              });
          });
          if (phrase.pendingDelete !== undefined) {
            phrase.pendingDelete.forEach(x =>
              this.$http.delete("/phrases/" + phrase.id + "/attachments/" + x)
            );
          }
        M.toast({ html: "Phrase saved" })
        },
        response => {}
      );
    },
    deletePhrase(phrase) {
      if (!phrase.id) {
        this.phrases.splice(this.phrases.indexOf(phrase), 1);
        M.Collapsible.getInstance(
          this.$el.querySelector(".collapsible")
        ).close();
      } else {
        let len = phrase.attachments.length;
        if (
          phrase.attachments == null ||
          phrase.attachments === undefined ||
          len == 0
        ) {
          this.$http.delete("/phrases/" + phrase.id).then(
            response => {
              this.phrases.splice(this.phrases.indexOf(phrase), 1);
            },
            response => {}
          );
        } else {
          phrase.attachments.forEach(x => {
            this.$http
              .delete("/phrases/" + phrase.id + "/attachments/" + x.id)
              .then(_ => {
                if (len-- == 0) {
                  this.$http.delete("/phrases/" + phrase.id).then(
                    response => {
                      this.phrases.splice(this.phrases.indexOf(phrase), 1);
                    },
                    response => {}
                  );
                }
              });
          });
        }
      }
    },
    savePhrase(phrase) {
      let newPhrase = Object.assign({},phrase);
      newPhrase.translations = phrase.translations.filter(t => t.text.length> 0)
      if (newPhrase.id == undefined) {
        this.addNewPhrase(newPhrase);
      } else {
        this.updatePhrase(newPhrase);
      }
      phrase.edit = false
    },
    freeLanguages(phrase) {
      if (phrase.translations == null) return this.languages;
      var allowedLangs = {};
      for (var l in this.languages) {
        if (!phrase.translations.some(t => t.language === l)) {
          allowedLangs[l] = this.languages[l];
        }
      }
      return allowedLangs;
    }
  },
  updated() {
    if (this.$el.querySelector(".select") != null) {
      M.Select.init(this.$el.querySelectorAll(".select"), {});
    }
    M.updateTextFields();
  },
  watch:{
    searchTerm: function (query) {
      this.phraseSearch();
      this.enities = 10;
    },
  },
  computed:{
    slicedPhrases: function(){
      return this.filteredPhrases.slice(0, this.enities)
    },
    filteredPhrases: function () {
      return this.phrases.filter(phrase => !phrase.title || phrase.title.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/Phrases.vue